/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonAction, ButtonType } from '@epg/ng-components';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'oneapp-button',
  templateUrl: './oneapp-button.component.html',
  styleUrls: ['./oneapp-button.component.scss'],
  standalone: false
})
export class OneappButtonComponent {
  @Input() action: ButtonAction = ButtonAction.CUSTOM;
  @Input() text = '';
  @Input() disabled = false;
  @Input() icon?: IconDefinition;
  @Input() secondaryIcon?: IconDefinition;
  @Input() type: ButtonType = ButtonType.DEFAULT;

  @Output() buttonClick = new EventEmitter<void>();

  deleteButton: ButtonAction = ButtonAction.DELETE;
  constructor() {}

  onClick() {
    this.buttonClick.next();
  }
}
